import {Button, IconButton} from "@zendeskgarden/react-buttons";
import {ReactComponent as NotesFill} from '@zendeskgarden/svg-icons/src/16/notes-fill.svg';
import {ReactComponent as NotesStroke} from '@zendeskgarden/svg-icons/src/16/notes-stroke.svg';
import {ReactElement, useMemo} from "react";
import * as css from "./styles/account-note-view-button.module.scss";


export interface IAccountNoteViewButtonProps {
    notePreview?: string | null;
    iconOnly?: boolean;
    onActivate: () => void;
}

export default function AccountNoteViewButton({notePreview, iconOnly, onActivate}: IAccountNoteViewButtonProps): ReactElement {
    const hasNote = useMemo(() => {
        return typeof notePreview === "string" && notePreview.trim() !== "";
    }, [notePreview]);

    if (iconOnly) {
        return (
            <IconButton
                isPrimary={hasNote}
                isBasic={false}
                onClick={onActivate}
            >
                {hasNote ? <NotesFill />: <NotesStroke />}
            </IconButton>
        )
    }

    return (
        <Button
            isBasic
            isStretched
            className={css.accountNoteButton}
            onClick={onActivate}
        >
            <Button.StartIcon>
                {hasNote ? <NotesFill /> : <NotesStroke />}
            </Button.StartIcon>
            <span>
                {hasNote ? notePreview : "Add Note"}
            </span>
        </Button>
    );
}
